module.exports = __webpack_public_path__ + "img/EXTERIOR-S-CROSS-3.e3118f21.jpg";